module.exports = __webpack_public_path__ + "assets/89e42f497df6b9ffc7e7aad6adece9e1.jpg";